import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "horse_racing_19772",
  "use": "horse_racing_19772-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 24 24\" id=\"horse_racing_19772\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 3a9 9 0 0 0-7.755 13.57l.69-5.29c.192-1.465.86-2.806 1.882-3.775C7.84 6.535 9.147 6 10.5 6H17l-1.284 2.107C16.48 8.56 17 9.43 17 10.444v7.112l-2.438.888-2.51-4.888c-.211-.41-.804-.205-.74.275L12.025 21A9 9 0 0 0 12 3z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol